export default "__VITE_ASSET__B5JGppN6__"